import { Route } from "@angular/router";

export const paymentRoutes: Route[] = [
    {
        path: "payment",
        loadComponent: () => import("../pages/payment/form/payment-form.page"),
    },
    {
        path: "charge/:type/payment",
        loadComponent: () =>
            import("../pages/payment/charge-result/charge-result.page"),
    },
    {
        path: "billing/:result",
        loadComponent: () =>
            import("../pages/payment/billing-result/billing-result.page"),
    },
];
